import {useStoredMeProperties} from "@/src/modules/core/store/me";
import {useStoredUserProperty} from "@/src/modules/core/store/user-property";
import type {Property} from "@/src/modules/properties/types";

/** Selected property from `me.properties` (full gate codes, contacts, managers). */
export function useDispatchDeskProperty(): Property | undefined {
  const userProperty = useStoredUserProperty();
  const meProperties = useStoredMeProperties();

  if (!userProperty?.id) return undefined;

  return meProperties.find((property) => property.id === userProperty.id);
}
